import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Base64 } from 'js-base64';
import { environment } from '@/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ReportesService {

  private endpoint: string | null;

  constructor
  (
    private httpClient: HttpClient
  ) 
  { 
    this.endpoint = Base64.decode(environment.apiEndpoint) + '/reportes/Reportes';
  }

  reporteRendimiento(buscador: any) {
  return this.httpClient.post(this.endpoint + '/Rendimiento', buscador);
  }

  reporteExcelRendimiento(buscador: any) {
    return this.httpClient.post(this.endpoint + '/DownloadExcel', buscador);
    }

  downloadLectorExcel(buscador: any){
    return this.httpClient.post(this.endpoint + '/DownloadLector', buscador);
  }

  borrarReporte(fileName: string) {
    const params = new HttpParams().set('fileName', fileName);
    return this.httpClient.delete(this.endpoint + '/BorrarReporte', { params });
  }

}
